import { CommonAccountDetails, CommonAccountState } from '@provider-portal/common/services/types';
// eslint-disable-next-line import/no-extraneous-dependencies -- it is already available due to redux-session library
import jwtDecode from 'jwt-decode';

import { GlobalAppState } from 'rdx/state';
import { consoleError } from 'utils/consoleError';

export function commonAccountAdapter(globalState: GlobalAppState): CommonAccountState {
  const accountDetails: CommonAccountDetails | null = globalState.account?.details
    ? {
        account_data: globalState.account.details.account_info.account_data,
        assignments: globalState.account.details.account_info.assignments,
        assignedProvidersByVendor:
          globalState.account.details.account_info.assignedProvidersByVendor,
      }
    : null;

  let vendorPermissions;
  try {
    const { accessToken } = globalState.session;
    const accountInfo = jwtDecode(accessToken) as
      | undefined
      | { data?: { vendor_permissions: { vendor_id: number }[] } };
    vendorPermissions = accountInfo?.data?.vendor_permissions.map(
      (vendorPermission) => vendorPermission.vendor_id,
    );
  } catch (e) {
    // TODO Shall we report it to bugsnag?
    consoleError(e);
  }

  return {
    details: accountDetails,
    requestState: globalState.account?.requestState,
    selectedProvider: globalState.account?.selectedProvider,
    selectedVendor: globalState.account?.selectedVendor,
    vendorPermissions,
  };
}
